import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Cabeçalho fixo no topo da tela.
 *
 * No celular a tela rola bastante (grid de prateleiras, formulário de cadastro):
 * sem cabeçalho fixo o título some e o "voltar" fica lá em cima, fora do alcance.
 * `voltar` aceita uma rota ou `true` (volta no histórico).
 */
export function PageHeader({
  titulo,
  subtitulo,
  voltar,
  acao,
}: {
  titulo: string;
  subtitulo?: string | null;
  voltar?: string | true;
  acao?: ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-20 -mx-4 mb-4 flex items-center gap-2 border-b border-adega-border/60 bg-adega-bg/90 px-2 pb-2 backdrop-blur"
      // Respeita o entalhe/barra de status quando o app está instalado.
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
    >
      {voltar ? (
        <button
          type="button"
          aria-label="Voltar"
          className="grid h-11 w-11 shrink-0 place-items-center rounded-full text-2xl text-adega-muted transition hover:text-adega-text active:bg-adega-surface-2"
          onClick={() => (voltar === true ? navigate(-1) : navigate(voltar))}
        >
          ‹
        </button>
      ) : (
        <span className="w-2 shrink-0" />
      )}

      <div className="min-w-0 flex-1 py-1">
        <h1 className="truncate text-lg font-semibold leading-tight">{titulo}</h1>
        {subtitulo ? <p className="truncate text-xs text-adega-muted">{subtitulo}</p> : null}
      </div>

      {acao ? <div className="shrink-0 pr-2">{acao}</div> : null}
    </header>
  );
}
